import { Flex, Loader, Portal } from '@fluentui/react-northstar';
import React, { useContext, useState } from 'react';
import { useFullPageLoadingContextProviderStyles } from './FullPageLoadingContextProvider.styles';
import { IFullPageLoadingContextProps } from './FullPageLoadingContextProvider.types';

const FullPageLoading = React.createContext<IFullPageLoadingContextProps>({
  isLoading: false,
  setIsLoading: (_state: boolean) => {
    return;
  }
});

export const FullPageLoadingContextProvider: React.FC = props => {
  const [isFullPageLoading, setIsFullPageLoading] = useState(false);
  const styles = useFullPageLoadingContextProviderStyles();

  return (
    <FullPageLoading.Provider
      value={{
        isLoading: isFullPageLoading,
        setIsLoading: setIsFullPageLoading
      }}
    >
      <Portal open={isFullPageLoading}>
        <Flex
          fill
          hAlign="center"
          vAlign="center"
          column
          styles={styles.flexDimmed}
        />
        <Flex
          fill
          hAlign="center"
          vAlign="center"
          column
          styles={styles.centerAbsolute}
        >
          <Loader />
        </Flex>
      </Portal>
      {props.children}
    </FullPageLoading.Provider>
  );
};

export const useFullPageLoadingContext = () => useContext(FullPageLoading);
